var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBasket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 15,
    viewBox: "0 0 16 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.00343 0C10.4887 0 12.5034 2.01472 12.5034 4.5V5.25H15.5034V6.75H14.6282L14.0607 13.5623C14.0283 13.951 13.7034 14.25 13.3133 14.25H2.69352C2.30346 14.25 1.9785 13.951 1.94611 13.5623L1.37792 6.75H0.503418V5.25H3.50342V4.5C3.50342 2.01472 5.51814 0 8.00343 0ZM13.1229 6.75H2.88317L3.38342 12.75H12.6227L13.1229 6.75ZM8.75343 8.25V11.25H7.25343V8.25H8.75343ZM5.75342 8.25V11.25H4.25342V8.25H5.75342ZM11.7534 8.25V11.25H10.2534V8.25H11.7534ZM8.00343 1.5C6.39678 1.5 5.08511 2.76298 5.00709 4.35027L5.00342 4.5V5.25H11.0034V4.5C11.0034 2.89335 9.74043 1.58169 8.15313 1.50367L8.00343 1.5Z",
    fill: "#2E3031"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBasket);
export default __webpack_public_path__ + "static/media/basket.bdd390f634fd96b813b16b940f4d116c.svg";
export { ForwardRef as ReactComponent };